import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import type { LimitedOrderingProductRequest } from "@shared/types/LimitedOrderingProductRequest";
import type { RetailerType } from "@shared/types/Retailer";

import ProductApprovalStore from "@shared/svelte/Stores/ProductApprovalStore";

type LimitedOrderingProductRequestParams = {
  retailer_id: number;
};
export enum SortOption {
  CreatedAtDesc = "created_at_desc",
  RetailerAsc = "retailer_asc",
  RetailerDesc = "retailer_desc",
  CreatedByAsc = "created_by_asc",
  CreatedByDesc = "created_by_desc",
}

export const SortOptions = [
  { label: "Most recent", value: SortOption.CreatedAtDesc },
  { label: "Location A - Z", value: SortOption.RetailerAsc },
  { label: "Location Z - A", value: SortOption.RetailerDesc },
  { label: "Requested by A - Z", value: SortOption.CreatedByAsc },
  { label: "Requested by Z - A", value: SortOption.CreatedByDesc },
];

export async function getLimitedOrderingProductsRes(
  params: LimitedOrderingProductRequestParams,
): Promise<LimitedOrderingProductRequest[]> {
  try {
    const res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/limited_ordering_product_requests/get_requests_by_group_director",
      data: params,
    });

    ProductApprovalStore.update(store => {
      return { ...store, productRequests: res };
    });
  } catch (e) {
    return [];
  }
}

export async function getGroupRetailers(): Promise<RetailerType[]> {
  try {
    const res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/retailers/for_current_group_director",
    });

    ProductApprovalStore.update(store => {
      return { ...store, retailers: res };
    });
  } catch (e) {
    return [];
  }
}

export function sortRequests(
  productRequests: LimitedOrderingProductRequest[],
  sortOption: SortOption = SortOption.CreatedAtDesc,
): LimitedOrderingProductRequest[] {
  const requestsCopy = [...productRequests];
  switch (sortOption) {
    case SortOption.CreatedAtDesc:
      requestsCopy.sort((a, b) => {
        const aCreatedAt = new Date(a.created_at).valueOf();
        const bCreatedAt = new Date(b.created_at).valueOf();

        return bCreatedAt - aCreatedAt;
      });
      break;
    case SortOption.CreatedByAsc:
      requestsCopy.sort((a, b) => {
        const anames = a.requested_by_user.full_name.split(" ")[1];
        const bnames = b.requested_by_user.full_name.split(" ")[1];

        if (anames === bnames) return 0;
        return anames > bnames ? 1 : -1;
      });
      break;
    case SortOption.CreatedByDesc:
      requestsCopy.sort((a, b) => {
        const anames = a.requested_by_user.full_name.split(" ")[1];
        const bnames = b.requested_by_user.full_name.split(" ")[1];
        if (anames === bnames) return 0;
        return anames < bnames ? 1 : -1;
      });
      break;
    case SortOption.RetailerAsc:
      requestsCopy.sort((a, b) => {
        const aretailer = a.retailer.name;
        const bretailer = b.retailer.name;

        if (aretailer === bretailer) return 0;
        return aretailer > bretailer ? 1 : -1;
      });
      break;
    case SortOption.RetailerDesc:
      requestsCopy.sort((a, b) => {
        const aretailer = a.retailer.name;
        const bretailer = b.retailer.name;
        if (aretailer === bretailer) return 0;
        return aretailer < bretailer ? 1 : -1;
      });
      break;
  }
  return requestsCopy;
}
